module.exports = __webpack_public_path__ + "static/img/icon_matron3.993ad955.png";